export default __webpack_public_path__ + "static/illustration-map-b83db9a3407488732580902f09234e66.svg";